import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import './Information.css';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="information-container">
      <SEO title={t('privacy.title')} description="Tietosuojakäytäntö – miten käsittelemme henkilötietojasi." path="/privacy" />
      <div className="container">
        <h1>{t('privacy.title')}</h1>
        <div className="information-content">
          <div className="information-section">
            <p>{t('privacy.content')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
